import { Button, Col, Row, Breadcrumb, Space, Table, Typography, Popconfirm } from 'antd';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { useState } from 'react';
import { CheckCircleFilled, CloseCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { openNotification } from '../../helpers';
import { useBlogAuthors } from '../../hooks/useBlogAuthors';
import { deleteBlogAuthor } from '../../services/blog-authors.http';

function BlogAuthorsList() {
  const [allParams, setAllParams] = useState({});
  const { blogAuthors, meta, isLoading, revalidate } = useBlogAuthors(allParams);

  const onDeleteClick = async (id) => {
    try {
      await deleteBlogAuthor(id);
      revalidate();
      openNotification('Success', `Deleted successfully!`);
    } catch (e) {
      console.log(e);
    }
  };

  const onTableChange = async (pagination, filters, sorter) => {
    const options = {
      // term: searchText,
      limit: pagination.pageSize,
      skip: (pagination.current - 1) * pagination.pageSize,
      sort: sorter.order === 'descend' ? `-${sorter.field}` : sorter.field,
      ...filters
    };

    setAllParams(options);
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (text, row) => {
        return (
          <div className="ml-2">
            <Link to={`/blog-authors/${row._id}/edit`} className="font-semibold">
              {text}
            </Link>
          </div>
        );
      }
    },

    {
      title: 'Active?',
      dataIndex: 'isActive',
      key: 'isActive',
      align: 'center',
      render: (text) =>
        text ? (
          <CheckCircleFilled className="text-green-500 text-lg" />
        ) : (
          <CloseCircleOutlined className="text-red-500 text-lg" />
        )
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: '20%',
      render: (text) => dayjs(text).format('DD/MM/YYYY hh:mm a')
    },

    {
      title: 'Action',
      key: 'action',
      width: '10%',
      render: (text, record) => (
        <Space size="middle">
          <Link to={`/blog-authors/${record._id}/edit`}>Edit</Link>
          <Popconfirm
            title="Are you sure to delete?"
            okText="Yes"
            cancelText="No"
            onConfirm={() => onDeleteClick(record._id)}>
            <a href="#">Delete</a>
          </Popconfirm>
        </Space>
      )
    }
  ];

  return (
    <div style={{ margin: 10 }}>
      <Breadcrumb items={[{ title: <Link to="/">Home</Link> }, { title: 'Blog Authors' }]} />
      <Row gutter={24} className="mt-4 mb-2">
        <Col span={12}>
          <Typography.Title level={4}>Blog Authors List</Typography.Title>
        </Col>
        <Col span={12} className="text-right">
          <Link to="/blog-authors/create">
            <Button type="primary" icon={<PlusOutlined />}>
              Add Blog Author
            </Button>
          </Link>
        </Col>
      </Row>

      <Table
        dataSource={blogAuthors}
        columns={columns}
        size="middle"
        onChange={onTableChange}
        rowKey={(row) => row._id}
        pagination={{
          total: meta?.total,
          pageSize: meta?.limit
        }}
        loading={isLoading}
      />
    </div>
  );
}

export default BlogAuthorsList;
